import ConfirmationModal from '@/components/ui-kit/confirmation-modal';
import { Dialog } from '@/components/ui-kit/dialog';
import { useToast } from '@/hooks/use-toast';
import { isErrorWithErrors } from '@/modules/gpt-chats/utils/error';
import { useDeleteModel } from '@/modules/gpt-chats/hooks/use-aimodel';

type DeleteModelProps = {
  modelId: string;
  open: boolean;
  onOpenChange: (value: boolean) => void;
};

import { useTranslation } from 'react-i18next';

export const DeleteModel = ({ modelId, open, onOpenChange }: DeleteModelProps) => {
  const { t } = useTranslation();
  const { mutateAsync } = useDeleteModel();
  const { toast } = useToast();

  const confirmHandler = async () => {
    try {
      if (!modelId) {
        toast.error({ errors: t('SOMETHING_WENT_WRONG') });
        return onOpenChange(false);
      }

      const res = await mutateAsync({ modelId: modelId });

      if (!res?.is_success) {
        return toast.error({ errors: (res as any).error ?? (res as any).detail });
      }

      toast({ description: t('MODEL_DELETED_SUCCESSFULLY'), variant: 'success' });
      onOpenChange(false);
    } catch (error) {
      if (isErrorWithErrors(error)) {
        return toast.error({ errors: error.errors });
      }
      return toast.error({ errors: t('SOMETHING_WENT_WRONG') });
    }
  };

  const handleOpenChange = (value: boolean) => {
    if (!value) {
      onOpenChange(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <ConfirmationModal
        data={{
          dialogTitle: t('DELETE_MODEL_TITLE'),
          dialogSubtitle: t('DELETE_MODEL_SUBTITLE'),
        }}
        onConfirm={confirmHandler}
        onCancel={() => onOpenChange(false)}
      />
    </Dialog>
  );
};
